<script setup>
import { useReferenceWorkspace } from "./referenceWorkspace";
import Platform365JourneyDetails from "@/components/Platform365JourneyDetails.vue";
const { reference, setSectionRef } = useReferenceWorkspace();
</script>

<template>
  <section
    v-if="reference.data?.platform365_journey"
    id="platform365-journey"
    :ref="(el) => setSectionRef('platform365-journey', el)"
    class="min-w-0 scroll-mt-24 2xl:col-span-12"
  >
    <div class="mb-3">
      <div
        class="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400"
      >
        Platform 365
      </div>
      <h2 class="text-xl font-semibold text-slate-900 dark:text-slate-100">
        Journey details
      </h2>
    </div>
    <Platform365JourneyDetails :journey="reference.data.platform365_journey" />
  </section>
</template>
